// NotificationContext.js
import React, { createContext, useState, useContext } from "react";

// Create context for notifications
const NotificationContext = createContext();

// Notification Provider to wrap the app and manage the notification state
export const NotificationProvider = ({ children }) => {
  const [notification, setNotification] = useState(null);

  const showNotification = (message, color = "success") => {
    setNotification({ message, color });
    setTimeout(() => {
      setNotification(null);
    }, 5000); // Auto-hide after 5s
  };

  return (
    <NotificationContext.Provider value={{ showNotification }}>
      {notification && (
        <div
          style={{
            position: "fixed",
            top: 20,
            right: 20,
            zIndex: 9999,
            minWidth: 300,
          }}
        >
          <div className="alert-wrapper">
            <div className={`alert alert-${notification.color}`} role="alert">
              {notification.message}
            </div>
          </div>
        </div>
      )}
      {children}
    </NotificationContext.Provider>
  );
};

// Custom hook to use the notification context
export const useNotification = () => useContext(NotificationContext);
